export const palette = {
  primaryBlue500: '#1EB4EE',
  primaryBlue400: '#20C1FF',
  primaryBlue600: '#1BA0D4',
  secondaryButtonBlue400: '#DFE8EB',
  secondaryButtonBlue600: '#CFE2E8',
  grey10: '#EDF3F5',
  grey20: '#EAEAEE',
  grey60: '#A3B7BF',
  grey80: '#587C87',
  grey100: '#385C66',
  alertRed: '#FF4D4D',
  green: '#9BC947',
  darkEmphasis: '#1D252D',
  primaryFilledBubble: '#64CEF8',
  bubbleColorFromBot: '#EBEBEF',
  primaryButtonShadow: 'rgba(30, 180, 238, 0.2)',
  transparent: 'rgba(0, 0, 0, 0)',


  mainBlue: '#0377C4',
  lightBlue: '#DBE9F3',
  navyBlue: '#1B4571',
  ctaButtonSalmon: '#CD4960',
  lightGreen: '#D0EAD0',
  lightYellow: '#FAF6EB',
  primaryClickState: '#3F98D2',
  primaryHoverState: '#0D7CC6',
  primaryFocusState: '#1782C9',
  secondaryClickState: '#E1EFF8',
  secondaryHoverState: '#F8FBFE',
  secondaryFocusState: '#F0F7FC',
  fadedBlue: '#81BCE4',
  ctaClickState: '#C15763',
  ctaFocusState: '#D1586D',
  mainText: '#343333',
  secondaryText: '#707070',
  mediumGray: '#B3B3B3',
  blackPopUpBG: 'rgba(0, 0, 0, 0.25)',
  lightGray: '#E5E5E5',
  disabledElement: '#F2F2F2',
  chatBGGray: '#F5F5F5',
  white: '#FFFFFF',
  black: '#000000',
  errorRed: '#B60000',
  primaryShadow: '#D9EBF7',
  primaryHoverShadow: '#C7E1F3',
  secondaryShadow: '#EBEBEB',
  sentMessage: '#D9EFFE'
}
